export const COMPLETE_SIGNUP_URL = '/recipient/complete-signup'
export const EMAIL_VERIFICATION_URL = '/recipient/verify'
export const FORGOT_PASSWORD_TOKEN_TO_JWT_URL = '/recipient/forgot-password-jwt'
export const FORGOT_PASSWORD_URL = '/recipient/forgot-password'
export const GET_RECIPIENT_DETAILS_URL = '/recipient/details'
export const LOGIN_URL = '/recipient/login'
export const REGISTER_RECIPIENT_URL = '/recipient/create'
export const RESEND_VERIFICATION_EMAIL_URL =
  '/recipient/resend-verification-email'
export const RESET_PASSWORD_URL = '/recipient/reset-password'
export const TOKEN_REFRESH_URL = '/token/refresh'
export const BASE_RECIPIENT_URL = '/recipient'

export const WALLET_EMAIL_TYPES = Object.freeze({
  PRIMARY: 'PRIMARY',
  REWARDS: 'REWARDS',
  OTHER: 'OTHER'
})
